import React, { ReactNode, useState, useEffect } from "react"
import Components from "../index"
import { unified } from "unified"
import remarkParse from "remark-parse"
import remarkRehype from "remark-rehype"
import rehypeReact from "rehype-react"
import remarkReactComponents from "../../helpers/remarkReactComponents"
import { blokType } from "../../types"
import {
  StyledTrigger,
  StyledBookings,
  StyledBookingsClose,
  StyledBookingsIcon,
  StyledBookingsImage,
  StyledBookingsTitle,
  StyledBookingsCopy,
  StyledBookingsLinks,
} from "./partials"
import IconV2 from "../icon-v2"
import Cookies from "js-cookie"

export interface BookingsProps {
  image: any
  title: string
  copy: blokType
  links: any
  icon_image: any
  text_color?: {
    color: string
  }
  background?: {
    color: string
  }
}

export const BookingsCmp: React.FC<BookingsProps> = ({
  image,
  title,
  copy,
  links,
  icon_image,
  text_color = { color: "#2b2b2b" },
  background = { color: "#e2effd" },
}) => {
  const [showPopup, setShowPopup] = useState(false)

  useEffect(() => {
    const popupCookie = Cookies.get("popupClosed")
    if (popupCookie) {
      setShowPopup(false)
    } else {
      const timeout = setTimeout(() => {
        setShowPopup(true)
      }, 10000) // 10 seconds in milliseconds

      // Clear the timeout when the component is unmounted to avoid any potential memory leaks
      return () => clearTimeout(timeout)
    }
  }, [])

  const handleTogglePopup = () => {
    if (showPopup) {
      setShowPopup(false)
      Cookies.set("popupClosed", "true", { expires: 7 })
    } else {
      setShowPopup(true)
    }
  }

  return (
    <>
      <StyledTrigger onClick={() => handleTogglePopup()}>
        {!showPopup ? (
          <>
            {icon_image ? (
              <StyledBookingsIcon
                src={icon_image.filename}
                title={icon_image.title}
                alt={icon_image.alt}
              />
            ) : (
              <>
                <IconV2 icon={"envelope"} size={"24"} iconType={"far"} />
              </>
            )}
          </>
        ) : (
          <IconV2 icon={"times"} size={"24"} iconType={"fal"} />
        )}
      </StyledTrigger>
      {showPopup && (
        <StyledBookings background_color={background.color}>
          <StyledBookingsClose onClick={() => handleTogglePopup()}>
            <IconV2 icon="times" size="16" iconType="fal" />
          </StyledBookingsClose>
          {image && (
            <StyledBookingsImage
              src={image.filename}
              title={image.title}
              alt={image.alt}
              // height="143"
            />
          )}
          {title && (
            <StyledBookingsTitle text_color={text_color.color}>
              {title}
            </StyledBookingsTitle>
          )}
          {copy && (
            <StyledBookingsCopy text_color={text_color.color}>
              {
                unified()
                  .use(remarkParse)
                  .use(remarkRehype)
                  .use(rehypeReact as any, {
                    createElement: React.createElement,
                    components: remarkReactComponents,
                    Fragment: React.Fragment,
                  })
                  .processSync(copy).result as ReactNode
              }
            </StyledBookingsCopy>
          )}
          {links && links.length > 0 && (
            <StyledBookingsLinks text_color={text_color.color}>
              {links.map((content: any) =>
                React.createElement(Components(content.component), {
                  key: content._uid,
                  blok: content,
                })
              )}
            </StyledBookingsLinks>
          )}
        </StyledBookings>
      )}
    </>
  )
}

export default BookingsCmp
